module.exports = __webpack_public_path__ + "static/media/plant3.f3e5cb6b.svg";